/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020,2021
 *
 *==================================================
 */
import { ProductDetailsWidget } from "@hcl-commerce-store-sdk/react-component";

import { withProductDetailsWidget } from "./hooks/use-product-details";

export default withProductDetailsWidget(ProductDetailsWidget);
